import { Component, Output, EventEmitter, Input } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { phosphorUpload, phosphorFile, phosphorX } from '@ng-icons/phosphor-icons/regular';
import { ToastService } from '../../../services/toast.service';
import { FileSystemService } from '../../../services/file-system.service';
import { Node } from '../../explorer/node';

@Component({
  selector: 'app-upload-file',
  imports: [DialogModule, NgIconComponent],
  templateUrl: './upload-file.component.html',
  styleUrl: './upload-file.component.css',
  providers: [provideIcons({ phosphorUpload, phosphorFile, phosphorX })],
})
export class UploadFileComponent {
  constructor(
    private fs: FileSystemService,
    private toast: ToastService
  ) {}

  @Input() singleFileMode: boolean = false;
  @Output() fileUploaded = new EventEmitter<Node>();

  uploadFileVisible: boolean = false;
  selectedFiles: File[] = [];
  isDragging: boolean = false;
  uploadedFilePath: Node | null = null;

  onClose(): void {
    this.selectedFiles = [];
    this.uploadFileVisible = false;
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      if (this.singleFileMode) {
        this.selectedFiles = [files[0]];
      } else {
        this.selectedFiles = Array.from(files);
      }
      // console.log('Files dropped:', this.selectedFiles);
    }
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    const files = input.files;
    if (files) {
      if (this.singleFileMode) {
        this.selectedFiles = [files[0]];
      } else {
        this.selectedFiles = Array.from(files);
      }
      // console.log('Files selected:', this.selectedFiles);
    }
  }

  async uploadFileSubmit() {
    if (this.selectedFiles.length > 0) {
      try {
        if (this.uploadedFilePath) {
          await this.fs.uploadFiles(this.selectedFiles, this.uploadedFilePath);
          this.toast.showSuccess(`Files uploaded successfully.`);
          this.fs.refreshRootNode();

          if (this.singleFileMode && this.selectedFiles.length > 0) {
            const uploadedFile = this.selectedFiles[0];
            const uploadedNode: Partial<Node> = {
              name: uploadedFile.name,
              path: `${this.uploadedFilePath.path}/${uploadedFile.name}`,
              isFolder: false,
              parentNode: this.uploadedFilePath,
            };
            this.fileUploaded.emit(uploadedNode as Node);
          }
        } else {
          this.toast.showError('No path selected.');
        }
      } catch (error) {
        this.toast.showError('Failed to upload some files. Please try again.');
        console.error('Upload error:', error);
      }
    } else {
      this.toast.showError('No file selected.');
    }
    this.onClose();
  }

  toggle(node: Node) {
    this.uploadedFilePath = node;
    this.uploadFileVisible = !this.uploadFileVisible;
  }
}
